package ui.new_ui.components.search

import emotion.react.css
import react.FC
import react.Props
import react.dom.html.ReactHTML
import ui.new_ui.components.card_item.CardStyles
import web.cssom.*
import web.html.InputType

external interface SearchProps : Props {
    var onUpdate: (String) -> Unit
}

val Search = FC<SearchProps> {props->
    ReactHTML.div{
        css {
            marginTop = SearchStyles.SearchBox.marginTop
        }

        ReactHTML.input{
            css {
                minHeight = SearchStyles.minHeight
                minWidth = SearchStyles.minWidth
                fontSize = SearchStyles.fontSize

                backgroundColor = SearchStyles.backgroundColor()
                padding = SearchStyles.innerPadding
                borderRadius = SearchStyles.borderRadius
                border = Border(
                    1.px,
                    LineStyle.solid,
                    SearchStyles.borderColor
                )
                boxShadow = BoxShadow(
                    offsetX = 0.px,
                    offsetY = 0.px,
                    blurRadius = SearchStyles.Shadow.shadowBlurRadius,
                    spreadRadius = SearchStyles.Shadow.shadowSpreadRadius,
                    color = SearchStyles.Shadow.shadowColor()
                )
            }
            onChange = {
                props.onUpdate(it.target.value)
            }
            type = InputType.search
            placeholder = "Поиск"
        }
    }
}